import(/* webpackMode: "eager" */ "/vercel/path0/src/app/gdpr-compliance/page.tsx");
